import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/pages/Dashboard.vue");
const Profile = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Profile.vue");
const Notifications = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Notifications.vue");
const Icons = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Icons.vue");
const Maps = () => import(/* webpackChunkName: "common" */ "@/pages/Maps.vue");
const Typography = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Typography.vue");
const TableList = () =>
  import(/* webpackChunkName: "common" */ "@/pages/TableList.vue");
const PayRoll = () =>
  import(/* webpackChunkName: "common" */ "@/pages/PayRoll.vue");
const EmployeeRecords = () =>
  import(
    /* webpackChunkName: "common" */ "@/pages/employemanagment/EmployeeRecords.vue"
  );

const EmployeeForm = () =>
  import(
    /* webpackChunkName: "common" */ "@/pages/employemanagment/EmployeForm.vue"
  );

const EmployeeDetails = () =>
  import(
    /* webpackChunkName: "common" */ "@/pages/employemanagment/EmployeDetail.vue"
  );

const PayrollList = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Payroll/PayrollList.vue");

const PayrollForm = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Payroll/PayrollForm.vue");

const PayrollSlip = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Payroll/PdfView.vue");

const ReportPAGIBIG = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Payroll/TextView.vue");

const LoansForm = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Loans/LoansForm.vue");
const LoansList = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Loans/LoansList.vue");
const LoanDetails = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Loans/LoanDetails.vue");

const LoginForm = () =>
  import(/* webpackChunkName: "common" */ "@/pages/Login/LoginForm.vue");

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/Login",
    children: [
      // {
      //   path: "dashboard",
      //   name: "dashboard",
      //   component: Dashboard,
      // },
      // {
      //   path: "profile",
      //   name: "profile",
      //   component: Profile,
      // },
      // {
      //   path: "notifications",
      //   name: "notifications",
      //   component: Notifications,
      // },
      // {
      //   path: "icons",
      //   name: "icons",
      //   component: Icons,
      // },
      // {
      //   path: "maps",
      //   name: "maps",
      //   component: Maps,
      // },
      // {
      //   path: "typography",
      //   name: "typography",
      //   component: Typography,
      // },
      // {
      //   path: "pay-roll",
      //   name: "pay-roll",
      //   component: PayRoll,
      // },

      {
        path: "/payroll",
        name: "payroll",
        component: PayrollList,
      },
      {
        path: "/payroll/new",
        name: "payroll-new",
        component: PayrollForm,
      },
      {
        path: "/payroll/:id/edit",
        name: "payroll-edit",
        component: PayrollForm,
        props: true,
      },
      {
        path: "/payroll/slip/:id",
        name: "payroll-slip",
        component: PayrollSlip,
        props: true,
      },
      {
        path: "employee-records",
        name: "employee-records",
        component: EmployeeRecords,
      },
      {
        path: "employee-records/new",
        name: "employee-records-new",
        component: EmployeeForm,
      },
      {
        path: "/employee-records/:id/edit",
        name: "employee-records-edit",
        component: EmployeeForm,
        props: true,
      },
      
	   
	  {
        path: "/employee-records/:id",
        name: "employee-records-details",
        component: EmployeeDetails,
        props: true,
      }, 
	   
      {
        path: "/payroll/txtSlip/:id",
        name: "payroll-txtSlip",
        component: ReportPAGIBIG,
        props: true,
      },

      // Loan routes
      {
        path: "/loans",
        name: "LoanList",
        component: LoansList,
      },
      {
        path: "/loans/create",
        name: "CreateLoan",
        component: LoansForm,
      },
      {
        path: "/loans/:id",
        name: "LoanDetails",
        component: LoanDetails,
        props: true,
      },
      {
        path: "/loans/:id/edit",
        name: "EditLoan",
        component: LoansForm,
        props: true,
      },

      {
        path: "/cutoffs",
        name: "CutoffList",
        component: () => import("@/pages/Cuttoff/CutOffList.vue"),
      },
      {
        path: "/cutoffs/create",
        name: "CutoffCreate",
        component: () => import("@/pages/Cuttoff/CutOffForm.vue"),
      },

      {
        path: "/cutoffs/:id",
        name: "payroll-show",
        component: 
        () => import("@/pages/Cuttoff/PayrollForCutOff.vue"),
        props: true,
      },

      {
        path: '/positions',
        name: 'PositionList',
        component: () => import('@/pages/Position/PositionList.vue')
      },
      {
        path: '/positions/create',
        name: 'PositionCreate',
        component: () => import('@/pages/Position/PositionForm.vue')
      },
      {
        path: '/positions/:id/edit',
        name: 'PositionEdit',
        component: () => import('@/pages/Position/PositionForm.vue'),
        props: true
      },
      {
        path: '/branches',
        name: 'BranchList',
        component: () => import('@/pages/Branch/BranchList.vue')
      },
      {
        path: '/branches/create',
        name: 'BranchCreate',
        component: () => import('@/pages/Branch/BranchForm.vue')
      },
      {
        path: '/branches/:id/edit',
        name: 'BranchEdit',
        component: () => import('@/pages/Branch/BranchForm.vue'),
        props: true
      }
,
      {
        path: '/reports-dashboard',
        name: 'ReportsDashboard',
        component: () => import('@/pages/Dashboard/ReportPage.vue')
      },
	
	  {
        path: "/Login",
        name: "Login",
        component: () => import('@/pages/Login/LoginForm.vue')
        
      }
      
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
